import LanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import TutorialScreenMediator from "./shared/TutorialScreenMediator";

export default class TutorialKeyDecisionsScreenMediator extends TutorialScreenMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {LanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, mediatorManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager);
        this._languagePack = languagePack;
        this._mediatorManager = mediatorManager;
    }

    initialize() {
        super.initialize();

        this._target.popupTitle.text = this._languagePack.getText('tutorial.key-decisions.popupTitle');
        this._target.popupDescription.text = this._languagePack.getText('tutorial.key-decisions.popupDescription');
        this._target.popupContinueButton.text = this._languagePack.getText('tutorial.key-decisions.popupContinueButton');
        this._target.popupTopic1Description.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1Description');
        this._target.EmailBG.popupTopic1EmailTo.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1EmailTo');
        this._target.EmailBG.popupTopic1EmailRecipient.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1EmailRecipient');
        this._target.EmailBG.popupTopic1EmailSubject.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1EmailSubject');
        this._target.EmailBG.popupTopic1EmailSubjectContent.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1EmailSubjectContent');
        this._target.EmailBG.popupTopic1EmailContent.text = this._languagePack.getText('tutorial.key-decisions.popupTopic1EmailContent');
        this._target.popupTopic2Description.text = this._languagePack.getText('tutorial.key-decisions.popupTopic2Description');
        this._target.popupTopic2KDBack.text = this._languagePack.getText('tutorial.key-decisions.popupTopic2KDBack');
        this._target.popupTopic2KDTitle.text = this._languagePack.getText('tutorial.key-decisions.popupTopic2KDTitle');
        this._target.popupTopic2KDDescription.text = this._languagePack.getText('tutorial.key-decisions.popupTopic2KDDescription');
        this._target.popupTopic3Description.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3Description');
        this._target.popupTopic3KDOverviewTitle.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewTitle');
        this._target.popupTopic3KDOverviewDisclaimer.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewDisclaimer');
        this._target.popupTopic3KDOverviewDescription.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewDescription');
        this._target.popupTopic3KDOverviewOptimalAnswers.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewOptimalAnswers');
        this._target.popupTopic3KDOverviewAnswer1.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewAnswer1');
        this._target.popupTopic3KDOverviewAnswer2.text = this._languagePack.getText('tutorial.key-decisions.popupTopic3KDOverviewAnswer2');

        super.initializeButton("popupContinueButton");
    }
        

    _handleContinueButton() {
        super._handleContinueButton();

        this.openScreen(SkinKeyRegistry.TUTORIAL_HUB_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 650, createjs.Ease.sineInOut)
        });
    }
}